// AMs open the Pipeline and Sales Dashboard filtered to their own initials (e.g. Scott Thornton → ST); everyone else sees All.
export const defaultAmFor = (role, name) => {
  if (role !== "account_manager") return "ALL";
  const ini = (name || "").split(/\s+/).filter(Boolean).map((p) => p[0].toUpperCase()).join("");
  return ini || "ALL";
};
